<template>
    <div class="header">
        <nav class="navbar navbar-expand-md navbar-light navbar--header d-block d-md-none">
            <a class="navbar-brand" :href="getUrl('homeUrl')">
                <img class="header--item--logo" src="~__STATIC__/logo_valle_nevado.svg" alt="Logo">
            </a>

            <div class="d-inline-block float-right">
                <button class="navbar-toggler" id="t" type="button" data-toggle="collapse"
                        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                    <icon-base :view-box-width="448" :view-box-height="512"
                               :icon-color="'#fff'" :height="30" :width="20">
                        <menu-bars-icon/>
                    </icon-base>
                </button>
            </div>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mr-auto">
                    <li class="nav-item pt-2 pb-2">
                        <a :href="getUrl('backtovalleUrl')" class="header--item--link" v-text="getTranslation('backtovalle')"></a>
                    </li>
                    <li class="nav-item pt-2 pb-2">
                        <a :href="getUrl('seasonpassesUrl')" class="header--item--link" v-text="getTranslation('seasonpassesLinkLabel')"></a>
                    </li>
                </ul>
            </div>
        </nav>

        <div class="container d-none d-md-block">
            <div class="row align-items-center">
                <div class="col-auto">
                    <div class="header--item">
                        <a href="/">
                            <img class="header--item--logo" src="~__STATIC__/logo_valle_nevado.svg" alt="Logo">
                        </a>
                    </div>
                </div>

                <div class="col-md-5 col-lg text-left header--wrapper">
                    <div class="header--item font-weight-bold pr-3">
                        <a :href="getUrl('backtovalleUrl')" class="header--item--link" v-text="getTranslation('backtovalle')"></a>
                    </div>
                    <div class="header--item font-weight-bold pr-3">
                        <a :href="getUrl('seasonpassesUrl')" class="header--item--link" v-text="getTranslation('seasonpassesLinkLabel')"></a>
                    </div>
                </div>

                <div class="col-auto text-right">
                    <!--<div class="mb-1">-->
                    <!--<div class="header&#45;&#45;item pl-2">-->
                    <!--<span class="flag-icon flag-icon-cl d-inline-block"></span>-->
                    <!--</div>-->
                    <!--<div class="header&#45;&#45;item pl-2">-->
                    <!--<span class="flag-icon flag-icon-us d-inline-block"></span>-->
                    <!--</div>-->
                    <!--<div class="header&#45;&#45;item pl-2">-->
                    <!--<span class="flag-icon flag-icon-br d-inline-block"></span>-->
                    <!--</div>-->
                    <!--</div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as Actions from '../store/action-types';
    import passescartMixin from '../mixins/passescartMixin';
    import siteConfig from '../mixins/siteConfig';

    export default {
        props: {
            showCart: {
                type: Boolean,
                default() {
                    return true;
                }
            }
        },

        mixins: [passescartMixin, siteConfig],

        computed: {
            user() {
                return window.Valle.user && window.Valle.user.name
                    ? window.Valle.user.name.split(' ')[0]
                    : undefined;
            },

            welcomeMessage() {
                return `${this.getTranslation('helloLabel')}, ${this.user}`;
            }
        },

        methods: {
            toggle() {
                this.$store.dispatch(Actions.toggleFooter);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/HeaderPasses.vue